import { DrivingLessonRecordState } from '@evidia/shared';
import type { DrivingLessonsRecord } from './Tabs/TrainingTab/TrainingTab';
import { STATE_MAP } from './Tabs/TrainingTab/useTrainingFileds';

export const resolveDrivingDataLessonsTitle = (item: DrivingLessonsRecord, prefix = 'Jízda') => {
	let hasError = false;
	if (item.lessonHours) {
		return { title: `${prefix} ${item.lessonHours.map(l => l + 1).join('-')}`, hasError };
	}

	hasError =
		item.state === DrivingLessonRecordState.CANCELLED_BY_STUDENT ||
		item.state === DrivingLessonRecordState.CANCELLED_BY_TEACHER;

	return { title: STATE_MAP[item.state], hasError };
};
